import { getApiBase } from "./apiBase";

const TOKEN_KEY = "respina_token";
const USER_KEY = "respina_user";

function emitAuthChanged() {
  if (typeof window === "undefined") return;
  try {
    const event = new CustomEvent("respina-auth-changed");
    window.dispatchEvent(event);
  } catch {
    // ignore
  }
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAuth(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
  emitAuthChanged();
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  emitAuthChanged();
}

export function getUser() {
  try {
    const s = localStorage.getItem(USER_KEY);
    return s ? JSON.parse(s) : null;
  } catch {
    return null;
  }
}

export function isAuthenticated() {
  return !!getToken();
}

export async function refreshUser() {
  if (!getToken()) return null;
  const base = getApiBase().replace(/\/+$/, '');
  const res = await fetch(`${base}/api/auth/me`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) return null;
  const user = data.user;
  if (user) {
    const s = localStorage.getItem("respina_user");
    const prev = s ? JSON.parse(s) : {};
    localStorage.setItem("respina_user", JSON.stringify({ ...prev, ...user }));
    emitAuthChanged();
  }
  return user;
}

export async function login(email, password) {
  const base = getApiBase().replace(/\/+$/, '');
  const res = await fetch(`${base}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Sign-in failed');
  setAuth(data.token, data.user);
  return data;
}

export async function deleteAccount() {
  const base = getApiBase().replace(/\/+$/, '');
  const res = await fetch(`${base}/api/auth/account`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Account deletion failed');
  clearAuth();
  return data;
}

export async function changePassword(currentPassword, newPassword) {
  const base = getApiBase().replace(/\/+$/, '');
  const res = await fetch(`${base}/api/auth/password`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Failed to change password');
  return data;
}

export async function register(email, password, name) {
  const base = getApiBase().replace(/\/+$/, '');
  const res = await fetch(`${base}/api/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, name }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Registration failed');
  setAuth(data.token, data.user);
  return data;
}
